import { $Fetch } from "ofetch";
import type { ApiAuthenticationHeader } from "~/types/shared/api.authentication.header";
import { useAuthStore } from "~/store/auth";

export default class HttpFactory {
  protected HTTP_GET = "GET";
  protected HTTP_POST = "POST";
  protected HTTP_PATCH = "PATCH";
  protected HTTP_DELETE = "DELETE";

  private readonly $fetch: $Fetch;
  constructor($fetch: $Fetch) {
    this.$fetch = $fetch;
  }

  async call<T>(
    method: string,
    url: string,
    headers?: HeadersInit,
    data?: object,
    extras = {}
  ): Promise<T> {
    return await this.$fetch(url, {
      method,
      headers,
      body: data,
      ...extras,
    });
  }

  protected getAuthenticationHeaders(): ApiAuthenticationHeader {
    const auth = useAuthStore();

    return {
      Authorization: "Bearer " + auth.getToken,
    };
  }
}
